// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"835":"43318b55","938":"3d8b1995"}[chunkId] + ".chunk.js";
};